export default __webpack_public_path__ + "static/media/SITE02_CREMATORIUM.06a8003d.png";